import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Menu, X, Search } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/podcast", label: "Podcast" },
  { to: "/ventures", label: "Ventures" },
  { to: "/build-dont-talk", label: "The Book" },
  { to: "/guest", label: "Be a Guest" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
  { to: "/aion", label: "Aion" },
] as const;


export function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-background/70 border-b border-border/50">
      <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
        <Link to="/" className="font-display font-bold tracking-tight text-lg">
          RAJ<span className="text-gradient-gold">.</span>SHAMANI
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              activeProps={{ className: "text-foreground font-medium" }}
              activeOptions={{ exact: l.to === "/" }}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/search"
            search={{ q: "" }}
            aria-label="Search this site"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Search size={18} />
          </Link>
        </nav>

        <button
          className="md:hidden text-foreground inline-flex items-center justify-center min-h-11 min-w-11 -mr-2"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden border-t border-border/50 bg-background px-6 py-4 flex flex-col gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="text-base text-muted-foreground hover:text-foreground py-3 min-h-11 flex items-center"
              activeProps={{ className: "text-gold font-medium" }}
              activeOptions={{ exact: l.to === "/" }}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/search"
            search={{ q: "" }}
            onClick={() => setOpen(false)}
            className="text-base text-muted-foreground hover:text-foreground py-3 min-h-11 flex items-center gap-2"
            activeProps={{ className: "text-gold font-medium" }}
          >
            <Search size={16} /> Search
          </Link>
        </nav>
      )}

    </header>
  );
}
